import React from "react"
import KEYBlue from "../common/keylist-blue"

const PHPwebServices: React.FC = () => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10 gap-5 md:gap-5 lg:gap-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">
            Let’s Have a Quick Glance Over Our PHP Web Development Services
              </h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Custom PHP Development" />
            <KEYBlue text="PHP based Web App Development" />
            <KEYBlue text="Maintenance & Support" />
            <KEYBlue text="Dynamic Website Development" />
              
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="PHP E-commerce Development" />
            <KEYBlue text="Classified Portal with PHP Website" />
            <KEYBlue text="PHP based Social Media Apps" />
            <KEYBlue text="PHP Built Forum Development" />

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PHPwebServices
